import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MIATableModel, ApiPagination } from '@mobileia/core';
import { BaseTableService } from 'src/app/services/base-table.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-base-related',
  templateUrl: './base-related.component.html',
  styleUrls: ['./base-related.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class BaseRelatedComponent<T> implements OnInit {

  isSending = false;
  isLoading = true;
  tableModel = new MIATableModel();
  displayedColumns = [];
  configColumns = [];
  dataItems = new ApiPagination<T>();
  service: BaseTableService<any>;
  serviceParent: BaseTableService<any>;
  item: any;
  newItem: T;
  configFields = [];
  pathUrlList = '';
  nameFieldParent = 'item_id';

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) { }

  ngOnInit(): void {
    this.searchFormByParams();
  }

  onClickSave() {
    this.isSending = true;
    this.service.save(this.newItem).toPromise().then(data => {
      this.isSending = false;
      if (!data.success) {
          this.alertService.showError('Error!', data.error.message);
          return;
        }
      this.alertService.showSuccess('Exito!', 'Se ha creado correctamente!.');
      this.loadItems();
    }).catch(error => {
      this.isSending = false;
      this.alertService.showError('Error!', error);
    });
  }

  loadItems() {
    this.isLoading = true;
    this.service.fetchList(this.tableModel).toPromise().then(data => {
        this.isLoading = false;
        if (!data.success) {
            this.alertService.showError('Error!', data.error.message);
            return;
        }
        this.dataItems = data.response;
    }).catch(error => {
        this.isLoading = false;
        this.alertService.showError('Error!', error);
    });
  }

  onRemove(item: any) {
    this.isLoading = true;
    this.service.remove(item.id).toPromise().then(data => {
        this.isLoading = false;
        if (data.success) {
            this.loadItems();
        }
    });
  }

  openItem(item: T) { }

  searchFormByParams() {
    // Buscar ID del tour
    this.route.params.subscribe(params => {
      if (params.id) {
        this.loadItem(params.id);
      } else {
        this.isLoading = false;
      }
    });
  }

  loadItem(itemId: number) {
    this.isLoading = true;
    this.serviceParent.fetch(itemId).toPromise().then(data => {
      if (!data.success) {
        this.navigator.navigateByUrl('/' + this.pathUrlList);
      }
      this.item = data.response;
      this.itemLoaded();
      this.tableModel.addWhere(this.nameFieldParent, this.item.id);
      this.loadItems();
    });
  }

  itemLoaded() { }
}
